import { Tab } from "react-bootstrap";
import { Tabs } from "react-bootstrap";
import ClaimReport from "../Report/Report";
import BranchClaimReport from "../Branches Report/Report";
import DepartmentClaimReport from "../Department Report/Report";
import CategoryClaimReport from "../Category Report/Report";
import secureLocalStorage from "react-secure-storage";
import ClaimSummaryReport from "../Summary Report/SummaryReport";
import "./style.css";
import "bootstrap/dist/css/bootstrap.min.css";
import DesignationClaimReport from "../Designation Report/Report";
import { Helmet } from "react-helmet-async";
function Report() {
  const user = JSON.parse(secureLocalStorage.getItem("profile"));
  return (
    <div
      style={{
        marginTop: "190px",
      }}>
      <Helmet title='Report - eClaim' />
      <Tabs
        style={{
          backgroundColor: "#CBD0D8",
          // border: "1px solid #000",
          fontSize: "16px",
          color: "#000",
        }}
        defaultActiveKey='claim'
        id='justify-tab-example'
        className='mb-2 custom-tabs'
        justify>
        <Tab eventKey='claim' title='Claim Report' className='custom-tab'>
          <ClaimReport />
        </Tab>
        <Tab eventKey='summary' title='Summary Report' className='custom-tab'>
          <ClaimSummaryReport />
        </Tab>

        <Tab eventKey='department' title='Department report'>
          <DepartmentClaimReport />
        </Tab>
        <Tab eventKey='category' title='Category report'>
          <CategoryClaimReport />
        </Tab>
        {user.results.branch === "head office" && (
          <Tab eventKey='branches' title='Branches report'>
            <BranchClaimReport />
          </Tab>
        )}
        <Tab eventKey='designation' title='Designation report'>
          <DesignationClaimReport />
        </Tab>
      </Tabs>
    </div>
  );
}

export default Report;
